import { gql } from '@apollo/client'

export const GET_ALL_CANCELLATION_REASON = gql`
  query GetAllCancellationReason(
    $limit: Int
    $offset: Int
    $searchQuery: String
  ) {
    getAllCancellationReason(
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      count
      rows {
        id
        reason
        description
        type
      }
    }
  }
`

export const GET_ALL_CANCELLATION_REASON_BY_TYPE = gql`
  query GetAllCancellationReasonByType(
    $type: String!
    $limit: Int
    $offset: Int
    $searchQuery: String
  ) {
    getAllCancellationReasonByType(
      type: $type
      limit: $limit
      offset: $offset
      searchQuery: $searchQuery
    ) {
      rows {
        id
        reason
        description
        type
      }
      count
    }
  }
`
